export default __webpack_public_path__ + "static/media/infinity.858cbc83.png";